import React, { ComponentType } from 'react';

import loadableComponent from 'react-loadable';

import { isServer } from '../../lib/environment';

function Loading() {
  return <div>Loading...</div>;
}

function dynamic<P>(
  loader: () => Promise<ComponentType<P> | { default: ComponentType<P> }>,
  { ssr }: { ssr?: boolean } = {},
) {
  if (isServer && ssr === false) {
    return Loading;
  }

  return loadableComponent({
    loader,
    loading: Loading,
  });
}

export default dynamic;
